import {
  SELECT_CONTACT_METHOD,
  FETCH_CONTACT_METHODS_REQUEST,
  FETCH_CONTACT_METHODS_SUCCESS,
  FETCH_CONTACT_METHODS_ERROR,
  POST_CONTACT_METHOD_REQUEST,
  POST_CONTACT_METHOD_SUCCESS,
  POST_CONTACT_METHOD_ERROR
} from './actions';
import ContactMethodModel from './model';

export const contactMethodStateDefaults = () => ({
  all: [],
  selected: {
    phone: {},
    sms: {},
    email: {}
  },
  errors: [],
  isLoading: false,
  isPosting: false
});

const contactMethodsReducer = (state = contactMethodStateDefaults(), action) => {
  switch (action.type) {
    case SELECT_CONTACT_METHOD:
      return {
        ...state,
        selected: {
          ...state.selected,
          [action.payload.type]: (new ContactMethodModel(action.payload.method)).asObject()
        }
      };
    case FETCH_CONTACT_METHODS_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case FETCH_CONTACT_METHODS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        all: action.payload.map((contact) => {
          const contactModel = new ContactMethodModel(contact);
          return contactModel.asObject();
        })
      };
    case FETCH_CONTACT_METHODS_ERROR:
      return {
        ...state,
        isLoading: false,
        errors: action.payload
      };
    case POST_CONTACT_METHOD_REQUEST:
      return {
        ...state,
        isPosting: true
      };
    case POST_CONTACT_METHOD_SUCCESS:
      return {
        ...state,
        isPosting: false,
        all: [
          ...state.all,
          action.payload
        ],
      };
    case POST_CONTACT_METHOD_ERROR:
      return {
        ...state,
        isPosting: false,
        errors: action.payload
      };
    default:
      return state;
  }
};

export default contactMethodsReducer;
